import { CookingColumn } from '../cooking-column';
import OrdersKanbanLayout from '../orders-kanban-layout';
import PendingToAcceptColumn from '../pending-to-accept-column/';
import { PendingToDeliverColumn } from '../pending-to-deliver-column';
import { useOrdersKanbanPage } from './hooks';
import {
  ScheduleTab,
  ScheduledOrdersList,
  useScheduleTab,
} from 'features/order/scheduled';

function OrdersKanbanPage({ title }) {
  const { hasAutoAccept, totalColumns } = useOrdersKanbanPage();
  const { activeTab } = useScheduleTab();

  const kanbanColumns = (
    <>
      {!hasAutoAccept && <PendingToAcceptColumn />}
      <CookingColumn hasAutoAccept={hasAutoAccept} />
      <PendingToDeliverColumn />
    </>
  );

  return (
    <OrdersKanbanLayout title={title} totalColumns={totalColumns}>
      {activeTab === ScheduleTab.InProgress ? (
        kanbanColumns
      ) : (
        <ScheduledOrdersList />
      )}
    </OrdersKanbanLayout>
  );
}

export default OrdersKanbanPage;
